import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    numOfOppContainer: (numOfOpportunities, isMapPage) => css`
      display: flex;
      align-items: center;
      justify-content: flex-end;
      ${!isMapPage &&
      css`
        margin: 2rem ${numOfOpportunities ? '2rem' : '5rem'};

        ${breakpoints.mm_l_xl} {
          margin: 2rem ${numOfOpportunities ? '2rem' : '5rem'};
        }
        ${breakpoints.mm_m_l} {
          margin: 2rem ${numOfOpportunities ? '2rem' : '5rem'};
        }
        ${breakpoints.mm_s_m} {
          margin: 2rem ${numOfOpportunities ? '2rem' : '3rem'};
        }
        ${breakpoints.mm_xs_s} {
          margin: 1.5rem ${numOfOpportunities ? '0rem' : '1rem'} 1rem;
        }
        ${breakpoints.mm_xxs_xs} {
          margin: 1.5rem ${numOfOpportunities ? '0rem' : '1rem'} 1rem;
        }
      `}
      ${isMapPage &&
      css`
        align-items: stretch;
        flex-direction: column;
        justify-content: center;
      `}
    `,
    numOfOppText: isMapPage => css`
      color: ${colors.ocean_depth_navy};
      font-size: ${isMapPage ? '0.7875rem' : '0.9375rem'};
      font-weight: 700;
      line-height: ${isMapPage ? '1rem' : '1.25rem'};
      text-transform: uppercase;
      letter-spacing: ${isMapPage ? '1.471px' : '0.24px'};
      ${breakpoints.mm_m_l} {
        font-size: 12.5px;
      }
      ${breakpoints.mm_s_m} {
        font-size: 12.5px;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 12.5px;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 12.5px;
      }
    `,
  };
};
